"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const listUsersUseCase_1 = require("@/useCases/users/listUsersUseCase");
const selectors_1 = require("@/store/ducks/users/selectors");
const users_1 = require("@/store/ducks/users");
const index_view_1 = __importDefault(require("./index.view"));
function UserTable() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const users = (0, react_redux_1.useSelector)(selectors_1.filteredUsersSelector);
    const areUsersLoading = (0, react_redux_1.useSelector)(selectors_1.areUsersLoadingSelector);
    const [order, setOrder] = react_1.default.useState("asc");
    const [orderBy, setOrderBy] = react_1.default.useState("username");
    const onRequestSort = (property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const onOpenEditUserModalForm = (user) => {
        dispatch((0, users_1.setUserToBeEdited)({
            id: user.id,
            email: user.email,
            username: user.username,
            roles: user.roles,
            department: user.department,
        }));
        dispatch((0, users_1.onOpenEditUserModal)());
    };
    const onShowDeleteAlert = react_1.default.useCallback((user, rowIndex) => {
        dispatch((0, users_1.openDeleteUserAlert)({
            userToBeDeleted: user,
            rowIndexToBeDeleted: rowIndex,
        }));
    }, [dispatch, users_1.openDeleteUserAlert]);
    const onAddUser = () => {
        dispatch((0, users_1.openCreateUserModal)());
    };
    react_1.default.useEffect(() => {
        (0, listUsersUseCase_1.listUsersUseCase)()(dispatch);
    }, []);
    return (react_1.default.createElement(index_view_1.default, { order: order, orderBy: orderBy, onAddUser: onAddUser, usersRows: users, isLoading: areUsersLoading, onRequestSort: onRequestSort, onOpenEditUserModalForm: onOpenEditUserModalForm, onShowDeleteAlert: onShowDeleteAlert }));
}
exports.default = UserTable;
